import _ from 'lodash';
import React, { Component } from 'react';
import Button from './Button';

// Import the CSS
import '../../scss/components/_button-group.scss';

export default class ButtonGroup extends Component {
	handleClickButton (name) {

		// Call the `onChange` method if the selection changes
		if (name !== this.props.selected) {
			this.props.onChange(name);
		}

	}

	render () {
		return (
			<div className="btn-group">
				{ this.props.children.map(button => {

					// Set the style based on whether the button is selected or not
					const style = this.props.selected === button.props.name ? null : 'gray-border';

					// Clone the button while doing the following:
					// 1. Assign a unique key.
					// 2. Override the `onClick` handler to proxy through the `onChange` prop.
					// 3. Override the `size` prop based on the button group's size.
					// 4. Override the `style` prop based on whether the button is selected or not.
					return React.cloneElement(button, _.assign({}, button.props, {
						key: button.props.name,
						onClick: () => this.handleClickButton(button.props.name),
						size: this.props.size,
						style,
					}));
				}) }
			</div>
		);
	}
}

ButtonGroup.propTypes = {
	selected: React.PropTypes.string.isRequired,
	size: React.PropTypes.string,
	onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/ButtonGroup.js